import { mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import { defineComponent, onMounted, reactive } from "vue";
import { openDataProps } from "./types";
function getUserKey(platform) {
  return platform === "pc" ? "qw-user" : "user";
}
const getUser = (platform = "pc") => {
  const localUser = window.localStorage.getItem(getUserKey(platform));
  return localUser ? JSON.parse(localUser) : {};
};
const TRIPARTITT_TYPE = 1;
const isQw = /wxwork/i.test(window.navigator.userAgent) || window.IS_QW;
var stdin_default = defineComponent({
  name: "OpenData",
  props: openDataProps,
  inheritattrs: false,
  setup(props, {
    attrs
  }) {
    const renderText = (name) => _createVNode("span", attrs, [name]);
    const isTripartite = props.isTripartite === void 0 ? (() => {
      const user = getUser(isQw ? "qw" : "pc");
      if (!user || !user.account_type) {
        return false;
      }
      return user.account_type === TRIPARTITT_TYPE;
    })() : props.isTripartite;
    const openDataRefs = reactive([]);
    const renderOpenData = (outName, type) => {
      const resultTag = (name, index, tagAttrs) => _createVNode(_resolveComponent("ww-open-data"), _mergeProps(tagAttrs, {
        "ref": (el) => openDataRefs[index] = el,
        "type": type,
        "openid": name
      }), null);
      if (props.separate) {
        const separateArray = Array.isArray(props.separate) ? props.separate : [props.separate];
        const reg = new RegExp(`[^${separateArray.join("^")}]+`, "g");
        const matchFlag = "\u2609";
        const resultStr = outName == null ? void 0 : outName.replace(reg, () => {
          return matchFlag;
        });
        const resultNameArr = outName == null ? void 0 : outName.match(reg);
        let index = 0;
        if (!resultNameArr) {
          return resultTag(outName, 0, attrs);
        }
        return _createVNode("span", attrs, [resultStr == null ? void 0 : resultStr.split("").map((itemName) => {
          return itemName === matchFlag ? resultTag(resultNameArr[index], index++) : itemName;
        })]);
      }
      return resultTag(outName, 0, attrs);
    };
    const renderNameTag = (name, type) => isTripartite ? renderOpenData(name, type) : renderText(name);
    const replaceMark = (text) => {
      const userType = "userName";
      const departmentType = "departmentName";
      const userReg = new RegExp(`${userType}\\=.*?`, "g");
      const departmentReg = new RegExp(`${departmentType}\\=.*?`, "g");
      const resultArr = text.split("$").map((item) => {
        var _a, _b;
        if ((_a = item.match(userReg)) == null ? void 0 : _a[0])
          return renderNameTag(item.replace(userReg, ""), userType);
        if ((_b = item.match(departmentReg)) == null ? void 0 : _b[0])
          return renderNameTag(item.replace(departmentReg, ""), departmentType);
        return item;
      });
      return _createVNode("span", null, [resultArr]);
    };
    onMounted(() => {
      var _a;
      if (isTripartite) {
        (_a = window.WWOpenData) == null ? void 0 : _a.bindAll(openDataRefs);
      }
    });
    return () => replaceMark(props.name);
  }
});
export {
  stdin_default as default
};
